module.exports = __webpack_public_path__ + "static/img/appdow_bk2_icon.333df6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/appdow_bk2_icon.png
// module id = JfZ4
// module chunks = 4